import React, { Component } from 'react';
import {
  Panel,
  Glyphicon,
  FormGroup,
  FormControl,
  Table,
} from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
import { invokeApig } from '../libs/awsLib';

const DefaultLocation = require('./CreateLocations-DefaultOjb.json');

const SalesforceMapping = {
  POS_NAME__c: 'id',
  Fridge_State__c: 'state',
  Fridge_City__c: 'city',
  Fridge_Street__c: 'street',
  Fridge_Zipcode__c: 'zipCode',
  Sales_Tax_Rate__c: 'taxRate',
  Vertical__c: 'vertical',
  Consumer_Friendly_Location__c: 'directions',
  Consumer_Friendly_NAme__c: 'prettyName',
  Access_Type__c: 'accessTo',
  Stocking_Date__c: 'onlineDate',
  MALongitude__c: 'longitude',
  MALatitude__c: 'latitude',
};

const defaultLatLong = {
  NJ: {
    long: -74.4057,
    lat: 40.0583,
  },
  NY: {
    long: -74.006,
    lat: 40.7128,
  },
  PA: {
    long: -77.1945,
    lat: 41.2033,
  },
  MA: {
    lat: 42.4072,
    long: -71.3824,
  },
  CT: {
    lat: 41.6032,
    long: -73.0877,
  },
  IL: {
    lat: 40.6331,
    long: -89.3985,
  },
  WI: {
    lat: 43.7844,
    long: -88.7879,
  },
  IN: {
    lat: 40.2672,
    long: -86.1349,
  },
};

export default class CreateLocations extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: false,
      cleanData: '',
    };
    this.saveLocations = this.saveLocations.bind(this);
    this.validateline = this.validateline.bind(this);
    this.validateFile = this.validateFile.bind(this);
  }

  async saveLocations(event) {
    this.setState({
      isLoading: true,
    });
    const localCleanData = this.state.cleanData;
    const remainingItems = [];

    for (let i = 0; i < localCleanData.length; i++) {
      const obj = localCleanData[i];
      if (this.validateline(obj) > 0) {
        const newObj = {};
        for (
          let index = 0;
          index < Object.keys(DefaultLocation).length;
          index++
        ) {
          const key = Object.keys(DefaultLocation)[index];
          newObj[key] = DefaultLocation[key];
        }
        newObj.latitude = defaultLatLong[obj.Fridge_State__c.toUpperCase()].lat;
        newObj.longitude =
          defaultLatLong[obj.Fridge_State__c.toUpperCase()].long;
        for (let index = 0; index < Object.keys(obj).length; index++) {
          const key = Object.keys(obj)[index];
          if (obj[key] === '') {
            // eslint-disable-next-line no-continue
            continue;
          }

          newObj[SalesforceMapping[key]] = obj[key];
          if (
            key === 'Fridge_State__c' &&
            ['NJ', 'NY', 'PA', 'MA', 'CT'].includes(obj[key].toUpperCase())
          ) {
            newObj.timeZone = 'NEWYORK';
            newObj.stockingSchedule.Sun = 1;
            newObj.stockingSchedule.Wed = 0;
            newObj.stockingSchedule.Fri = 0;
            newObj.priceMapTemplate = 'PMT_NE_STANDARD';
          }
        }
        let apiResponse;
        try {
          apiResponse = await invokeApig({
            path: '/locations',
            method: 'POST',
            body: newObj,
          });
        } catch (error) {
          console.error(apiResponse);
          console.error(error);
          remainingItems.push(obj);
        }
      } else if (this.validateline(obj) < 0) {
        remainingItems.push(obj);
      }
    }
    this.setState({
      cleanData: remainingItems,
      isLoading: false,
    });
  }

  // TODO: rewrite to prevent param reassigning
  handleFileChange = (event) => {
    this.setState({
      cleanData: [],
    });
    window.Papa.parse(event.target.files[0], {
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        // eslint-disable-next-line no-param-reassign
        results.data = results.data.map((item) => {
          // eslint-disable-next-line no-param-reassign
          item.POS_NAME__c = item.POS_NAME__c.toString();
          return item;
        });
        this.setState({
          cleanData: results.data,
        });
      }.bind(this),
    });
    this.setState({
      // TODO: Check if can we safety remove this unused state
      // eslint-disable-next-line react/no-unused-state
      file: event.target.files[0],
    });
  };

  validateline(item) {
    const item_keys = Object.keys(item);
    const required_keys = ['POS_NAME__c'];
    for (let i = 0; i < required_keys.length; i++) {
      const key = required_keys[i];
      if (!item_keys.includes(key)) {
        return -1;
      }
    }
    for (let i = 0; i < required_keys.length; i++) {
      const key = required_keys[i];
      if (item[key] === '') {
        return -1;
      }
    }
    if (item.Business_Hours__c !== '24 Hours') {
      return -1;
    }
    return 1;
  }

  validateFile() {
    if (this.state.fileContents === '') {
      return true;
    }
    return false;
  }

  render() {
    const headers = Object.keys(SalesforceMapping);
    let headerCells;
    let rows;
    if (this.state.cleanData.length > 0) {
      headerCells = headers.map((header) => <th key={header}>{header}</th>);
      rows = this.state.cleanData.map(
        function (obj) {
          const tds = headers.map((header) => (
            <td key={header}>{obj[header]}</td>
          ));
          tds.push(
            <td key="status">
              {this.validateline(obj) > 0 && <Glyphicon glyph="ok" />}
              {this.validateline(obj) === 0 && <Glyphicon glyph="refresh" />}
              {this.validateline(obj) < 0 && (
                <Glyphicon glyph="exclamation-sign" />
              )}
            </td>,
          );
          return <tr key={JSON.stringify(obj)}> {tds} </tr>;
        }.bind(this),
      );
    }
    return (
      <div className="Locations">
        <Panel id="Help Panel">
          <Panel.Heading>
            <Panel.Title toggle>
              <Glyphicon glyph="question-sign" />
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <p>
                <strong>Notes</strong>
              </p>
              <ul>
                <li>Only 24 Hour fridges are supported at this time</li>
                <li>Fields that need to be updated at time of install</li>
                <ul>
                  <li>
                    Coordinates: <strong>Longitude, Latitude</strong> are set to
                    default values based on state
                  </li>
                  <li>
                    <strong>Layout</strong> is set to `dummy` and needs to be
                    updated
                  </li>
                </ul>
                <li>Current Mappings between Salesforce and CMS:</li>
                <ul>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Salesforce</th>
                        <th>CMS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(SalesforceMapping).map((sf_key) => (
                        <tr>
                          <td key={sf_key}>{sf_key}</td>
                          <td key={SalesforceMapping[sf_key]}>
                            {SalesforceMapping[sf_key]}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </ul>
              </ul>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
        <FormGroup controlId="file">
          <FormControl
            onClick={(event) => {
              // eslint-disable-next-line no-param-reassign
              event.target.value = null;
            }}
            onChange={this.handleFileChange}
            type="file"
          />
        </FormGroup>

        {this.state.cleanData.length > 0 && (
          <Table bordered responsive>
            <thead>
              <tr>{headerCells}</tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        )}

        <LoaderButton
          block
          bsStyle="primary"
          bsSize="large"
          disabled={this.validateFile()}
          onClick={this.saveLocations}
          type="submit"
          isLoading={this.state.isLoading}
          text="Create new locations"
          loadingText="Uploading Locations…"
        />
      </div>
    );
  }
}
